import React, { MouseEventHandler, ReactElement } from 'react';
import { useMobileViewDetection } from '../../utils/window';
import { Button, IconButton } from '@mui/material';

type ResponsiveButtonProps = {
    icon: ReactElement;
    color?:
        | 'inherit'
        | 'primary'
        | 'secondary'
        | 'success'
        | 'error'
        | 'info'
        | 'warning';
    children: ReactElement | string;
    onClick?: MouseEventHandler;
};

export default function ResponsiveButton({
    icon,
    color,
    children,
    onClick,
}: ResponsiveButtonProps) {
    const { isMobile } = useMobileViewDetection();

    if (isMobile) {
        return (
            <IconButton color={color} onClick={onClick} size="large">
                {React.createElement(icon.type, {
                    ...icon.props,
                    style: { fontSize: 20 },
                })}
            </IconButton>
        );
    }

    return (
        <Button color={color} startIcon={icon} onClick={onClick} size="small">
            {children}
        </Button>
    );
}
